<template>
<div class="chapter">
<div class="inner_page">
<p class="cpytxt"><br/><br/><a id="copy"></a><b>ZONDERVAN</b></p>
<p class="cpytxt"><em>Emerald Windows</em><br/>Copyright © 2001 by Terri Blackstock</p>
<p class="cpytxt">All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this ebook on screen. No part of this text may be reproduced, transmitted, downloaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan.</p>
<p class="cpytxt">ePub Edition JULY 2009 ISBN: 978-0-310-83026-9</p>
<p class="cpytxt">Requests for information should be addressed to: </p>
<p class="cpytxt">Zondervan, <em>Grand Rapids, Michigan 49530</em></p>
<p class="line1"> </p>
<p class="cpytxt1"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="cpytxt"><b>Blackstock, Terri,</b>1957-</p>
<p class="cpytxt-indent">Emerald windows / Terri Blackstock.</p>
<p class="cpytxt-indent" style="text-indent: 4.5em;">p. cm. </p>
<p class="cpytxt-indent">ISBN 0-310-22807-7</p>
<p class="cpytxt-indent">1. Glass painting and staining—Fiction. I. Title.</p>
<p class="cpytxt" style="text-indent: 1.5em;">PS3552.L34285 E5 2001</p>
<table width="150%">
<tbody><tr>
<td style="text-indent: 1.5em;"><p class="cpytxt1">813’.54—dc21</p></td>
<td><p class="cpytxt1">2001045382</p></td>
</tr>
</tbody></table>
<p class="line"> </p>
<p class="cpytxt">All Scripture quotations, unless otherwise indicated, are taken from the <em>Holy Bible: New International Version</em>®<em>.</em> NIV®. Copyright © 1973,1978,1984 by International Bible Society. Used by permission of Zondervan. All rights reserved.</p>
<p class="cpytxt">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="cpytxt">Published in association with the literary agency of Alive Communications, Inc., 7680 Goddard Street, Suite 200, Colorado Springs, CO 80920.</p>
<p class="cpytxt"><em>Interior design by Beth Shagene</em></p>
<p class="cpytxt"><em>Printed in the United States of America</em></p>
<p class="line2"> </p>
<p class="cpytxt-center">05 06 07 08 / <img alt="image" src="images/image1.jpg"/> DC/ 10 9</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005copyright.vue?73777d41